import React, { forwardRef } from 'react';
import get from 'lodash.get';
import { Checkbox } from '@mui/material';

import { Error, StyledCheckboxWrapper, StyledDisclaimerWrapper, StyledDisclaimer } from './styles';

const CheckboxInput = forwardRef(
  ({ className, name, defaultChecked, label: disclaimer, onChange, onBlur, errors }, ref) => {
    const error = get(errors, name, false);
    const label = { inputProps: { 'aria-label': 'Checkbox' } };

    return (
      <StyledCheckboxWrapper className={className}>
        <div>
          <Checkbox
            {...label}
            id={name}
            name={name}
            defaultChecked={defaultChecked}
            ref={ref}
            onChange={onChange}
            onBlur={onBlur}
            className={error ? 'checkbox-error' : ''}
          />
        </div>
        <StyledDisclaimerWrapper>
          <StyledDisclaimer>{disclaimer}</StyledDisclaimer>
          {!!error && (
            <Error component="p" variant="DS_copySmallRegular" className="error-checkbox-msg">
              {error?.message || 'Required'}
            </Error>
          )}
        </StyledDisclaimerWrapper>
      </StyledCheckboxWrapper>
    );
  },
);
export default CheckboxInput;
